<div class="col new-gradient non-supported-body">
  <h2>Following features are not working in IE:</h2>
  <ul class="list">
    @for (feature of nonIEFeatures; track feature) {
      <li class="list-item">{{feature}}</li>
    }
  </ul>

  <div class="browser-download-table">
    <h5>We recommend dowloading and using any of the following browser, <br>
    to access and use all features seamlessly.</h5>
    <table>
      <ul class="browser-list">
        @for (browser of browserList; track browser) {
          <li class="list-item">
            <span>{{browser.name}}</span>
            <a [href]="browser.downloadLink" class="btn btn__orange" target="_blank">Download {{browser.name}}</a>
          </li>
        }
      </ul>
    </table>
  </div>
</div>